import { AuditData } from '@alberta/swodoc-document-generator/dist/domain/Audit/Audit';

export class AuditReportGenerator {
  public async generate(data: AuditData): Promise<AuditData> {
    return data;
  }
}
